import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import FingerDermalPiercingImage from '../../Assets/Piercing Services/Finger dermal piercing.png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function FingerDermalPiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
          <title>Finger Dermal Piercing UAE | 450 AED</title>
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Finger Dermal Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Finger Dermal Piercing 450 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={FingerDermalPiercingImage} alt="Finger Dermal Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Finger Dermal Piercing</h3>

          <p>
            Make a bold and unique fashion statement with our professional finger dermal piercing services in the UAE, available at a premium price of 450 AED. Finger dermal piercing is a trendy and eye-catching surface piercing that places a small, elegant piece of jewelry directly on the skin of the finger, creating the illusion of a permanent accessory. This modern style is perfect for individuals who want something different from traditional rings and are looking to express their individuality with a distinctive and fashionable look. Whether you choose a subtle crystal or a decorative top, finger dermal piercing offers a minimal yet striking aesthetic that instantly elevates your style.
          </p>

          <p>
            At our piercing studio, safety, hygiene, and precision are our top priorities. Our certified professionals use sterile, single-use, high-quality equipment to perform each finger dermal piercing with exceptional care and accuracy. We strictly follow professional hygiene protocols to maintain a clean and sanitized environment, minimizing the risk of infection and ensuring a safe and smooth experience. Dermal piercings require specialized techniques and expertise, and our experienced specialists are trained to ensure proper placement and stability, helping to achieve long-lasting and visually appealing results while minimizing discomfort.
          </p>

          <p>
            Finger dermal piercing is ideal for individuals who want a unique and modern body modification that stands out in a subtle yet stylish way. Its placement on the finger makes it a standout accessory, offering a creative alternative to traditional jewelry. This piercing can be worn alone for a clean and minimalist look or combined with other piercings to create a personalized aesthetic. Our specialists take the time to understand your preferences and guide you in selecting the best placement and jewelry design to suit your lifestyle and style goals.
          </p>

          <p>
            The procedure is typically quick and efficient, making it convenient even for clients with busy schedules. Our team uses advanced techniques designed to reduce discomfort and promote effective healing, ensuring that you can enjoy your new piercing with confidence. We also provide high-quality, hypoallergenic dermal jewelry that is safe for sensitive skin, helping to prevent irritation and ensuring a smoother healing process.
          </p>

          <p>
            Our clean, welcoming, and professional environment ensures that every client feels comfortable and confident throughout their visit. We understand that dermal piercings can feel intimidating, especially for first-time clients, and our friendly staff is always available to answer your questions and provide reassurance. From consultation to completion, we focus on delivering a smooth and positive experience tailored to your needs.
          </p>

          <p>
            Aftercare is especially important for finger dermal piercings due to frequent hand movement and exposure. We provide detailed instructions to help you care for your piercing properly, including cleaning routines, protective measures, and precautions to avoid irritation or displacement. Following proper aftercare is essential for maintaining the longevity and appearance of your piercing.
          </p>

          <p>
            Our finger dermal piercing services in the UAE combine premium quality with transparent pricing, ensuring you receive exceptional value without hidden costs. Booking your appointment is quick and convenient, allowing you to choose a time that suits your schedule. We aim to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Choose our trusted finger dermal piercing services in the UAE for a safe, hygienic, and professional experience. With skilled specialists, precise techniques, and a strong focus on customer satisfaction, we help you achieve a unique and stylish look effortlessly. Book your finger dermal piercing appointment today and express your individuality with confidence and expert care.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Finger Dermal Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default FingerDermalPiercing;